import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getPartnerInfoOfSelectedTicket,
  getSmbOfSelectedTicket,
  getBrandOfSelectedTicket,
  getHomepageOfSelectedTicket,
} from 'extractFromState';
import { setCenterPaneExtraInfoPanelActive } from 'actions';
import moment from 'moment-timezone';
import { Section, SectionHeader, Header, HomepageHeader, Timestamp } from './PartnerInfo.styles';

const PartnerInfo = ({ partnerInfo, partnerName, partnerBrand, setCenterPaneInfoPanelActive, homepageUrl }) => {
  const [activeIdx, setActiveIdx] = useState(0);

  const isSectionActive = (idx) => {
    return idx === activeIdx;
  };

  const handleSectionToggle = (idx) => {
    if (activeIdx === idx) {
      return setActiveIdx(null);
    }

    setActiveIdx(idx);
  };

  const getHomepageUrlDisplay = () => {
    return homepageUrl && homepageUrl.replace('https://', '');
  };

  const renderMostRecentUpdateTime = () => {
    const updatesArray = partnerInfo.map((info) => info['updatedAt']);
    if (updatesArray.length === 0) {
      return;
    }
    const maxDateInUpdatesArray = updatesArray.reduce((a, b) => (a > b ? a : b)); // returns the most recent timestamp
    if (maxDateInUpdatesArray === undefined) {
      return;
    }
    const formattedDate = moment(maxDateInUpdatesArray).format('MM/DD/YY');
    const formattedTime = moment(maxDateInUpdatesArray).format('h:mm A');
    const regex = /\d/; // check for digits
    const dateHasDigits = regex.test(formattedDate);
    const timeHasDigits = regex.test(formattedTime);
    if (!dateHasDigits || !timeHasDigits) {
      return;
    }
    const localTz = moment.tz.guess();
    const formattedTz = moment().tz(localTz).format('z');

    return (
      <Timestamp>
        <span>
          <br />
          Updated:
        </span>
        <span>{`${formattedDate}`}</span>
        <span>{`${formattedTime} ${formattedTz}`}</span>
      </Timestamp>
    );
  };

  return (
    <>
      <Header>
        <h1>Welcome to {partnerBrand || partnerName}</h1>
        <img onClick={() => setCenterPaneInfoPanelActive(false, null)} src="/images/close-x-small.svg" alt="close" />
        {!!homepageUrl && (
          <HomepageHeader>
            {'Visit company website: '}
            <a href={homepageUrl} target="_blank" rel="noopener noreferrer">
              {getHomepageUrlDisplay()}
            </a>
            <div>{renderMostRecentUpdateTime()}</div>
          </HomepageHeader>
        )}
      </Header>
      {partnerInfo.map((section, idx) => (
        <Section active={isSectionActive(idx)}>
          <SectionHeader>
            <h2>{section.title}</h2>
            <div onClick={() => handleSectionToggle(idx)}>
              {isSectionActive(idx) ? 'Hide' : 'Show'}
              <img
                src={`images/new-designs/${isSectionActive(idx) ? 'chevron-up' : 'chevron-down'}.svg`}
                alt="expand"
                onClick={() => this.onOpen()}
              />
            </div>
          </SectionHeader>
          {isSectionActive(idx) && <p>{section.body}</p>}
        </Section>
      ))}
    </>
  );
};

const mapStateTopProps = (state) => ({
  homepageUrl: getHomepageOfSelectedTicket(state),
  partnerInfo: getPartnerInfoOfSelectedTicket(state),
  partnerName: getSmbOfSelectedTicket(state),
  partnerBrand: getBrandOfSelectedTicket(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setCenterPaneInfoPanelActive: setCenterPaneExtraInfoPanelActive,
    },
    dispatch
  );

export default connect(mapStateTopProps, mapDispatchToProps)(PartnerInfo);
